/**
 * Created by claudio iozzia on 04/07/2017.
 */
import {Utils} from "../../../../common/utils";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {EntityError} from "../../../../models/EntityAlert";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic, IEntityAlert} from "../../../../models/common";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Validator_DcDc_Buck} from "./dcdc_buck_validator";
import {IC_fsw} from "../../../../models/IC_fsw";

export class Validator_DcDc_MultiBuck extends Validator_DcDc_Buck {

  private validatorFn_SingleOutput_Voltage_MultiBuck: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const dMax: number = Math.min(new IC_fsw(ic).dMax, 0.98);
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const _vin = spec.spec.value.input;
    const voutMin: number = Utils.getFieldValue(ic, "validator.output." + o + ".vout_min", NaN);
    const voutMax: number = Utils.getFieldValue(ic, "validator.output." + o + ".vout_max", NaN);

    const isAttendibileVinMin: boolean = !spec.spec.note.input.min.hasError && Utils.isValueReal(_vin.min);
    const isAttendibileVinMax: boolean = !spec.spec.note.input.max.hasError && Utils.isValueReal(_vin.max);

    let vOutUpperBound: number;

    if (isAttendibileVinMin) {
      vOutUpperBound = _vin.min * dMax;
    } else if (isAttendibileVinMax) {
      vOutUpperBound = _vin.max * dMax;
    } else {
      vOutUpperBound = voutMax;
    }

    if (ic.vout_max < vOutUpperBound) {
      vOutUpperBound = voutMax;
    }

    vOutUpperBound = ValueFormatter.scale(vOutUpperBound, siPrefix.unit, 1, "f");

    const result = Utils.acceptInRange(_vOut, voutMin, vOutUpperBound, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_MultiBuck: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _iOut = spec.spec.value.output.outputs[o].current;
    const ioutMax: number = Utils.getFieldValue(ic, "validator.output." + o + ".iout_max", NaN);

    const result = Utils.acceptUpTo(_iOut, ioutMax, "Iout", "A");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_MultiBuck];
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_MultiBuck];
  }

}
